import React from "react";

const DetailItem = (props) => {
  return (
    <p className={`detailItem${props.className ? ` ${props.className}` : ""}`}>
      <span className="detailItem__flag">{props.flag}</span>
      <span className="detailItem__details">{props.details}</span>
    </p>
  );
};
export default DetailItem;
